import React from "react";
import { func, shape, string, arrayOf, bool } from "prop-types";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { isMobile, isIpad, isDesktop } from '../../global/ScreenSizeHelper';

const TabsContainer = ({
  value,
  onChange,
  options,
  backgroundColor,
  activeFontColor,
  inactiveFontColor,
  isLoggedIn
}) => {

  const navigate = useNavigate();

  const onTabChange = (optionValue, to) => {
    onChange(optionValue);
    navigate(to);
  }

  return (
    <>
      <div className={isIpad ? "custom-tabs medium" : "custom-tabs"}>
        {options.filter(tab => !(tab.hideOnLogin && isLoggedIn)).map((tab) => {
          const { label, value: optionValue, to } = tab;
          return (
            <button
              className={`tab ${optionValue === value ? 'active' : ''}`}
              type="button"
              key={optionValue}
              onClick={() => onTabChange(optionValue, to)}
            >
              {label}
            </button>
          );
        })}
      </div>
    </>
  );
};

export default TabsContainer;

TabsContainer.propTypes = {
  screenSize: string,
  value: string,
  onChange: func,
  options: arrayOf(
    shape({
      label: string,
      value: string,
    })
  ),
  backgroundColor: string,
  activeFontColor: string,
  inactiveFontColor: string,
  isLoggedIn: bool
};
TabsContainer.defaultProps = {
  screenSize: "",
  value: "",
  onChange: null,
  options: [],
  backgroundColor: undefined,
  activeFontColor: undefined,
  inactiveFontColor: undefined,
};
